import { createAction } from '@ngrx/store';
import { IndieSensorInternalModel } from '@spog-ui/shared/models/indie-sensors';

export const loadAction = createAction(
  '[Indie Sensor State] Load Industrial Sensors',
  (indieSensors: IndieSensorInternalModel[]) => ({ indieSensors }),
);
